import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'What a Cursor usage event was, when it happened, and against what.',
    name: 'Cursor Usage Events',
    partialId: PartialId.Standard.create('cursor_usage_events'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
